import { trace } from 'rytm-helpers';
import { scrollToTargetForce } from '../scrolling';

export const initScrollTo = () => {
  // add click event to document
  document.addEventListener('click', onDocumentClick);
}

/**
 * Event handlers
 */
const onDocumentClick = (e) => {
  const scrollLink = e.target.closest('[data-scroll-to]');
  if (scrollLink) {
    const targetSelector = scrollLink.dataset.scrollTo;
    const offset = scrollLink.dataset.scrollToOffset ? parseInt(scrollLink.dataset.scrollToOffset) : 0;
    if (targetSelector) {
      e.preventDefault();
      scrollToTargetForce(targetSelector, {duration: 1.8, offset});
    }
  }
}
